import axios from 'axios';
import { apiBaseUrl, host } from '@/environment/environment';

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
axios.defaults.withCredentials = true;

const config = {
  baseURL: host + apiBaseUrl,
  withCredentials: true,
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to
 * consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 * */
const httpClient = axios.create(config);

/**
 * Auth interceptors
 * @description Configuration related to AUTH token can be done in interceptors.
 * Currenlty it is just doing nothing but idea to to show the capability of axios
 * and its interceptors
 * In future, interceptors can be created into separate files and consumed
 * into multiple http clients
 * @param {*} config
 */

/** Adding the response interceptors */
httpClient.interceptors.response.use(
  response => response,
  (error) => {
    Promise.reject(error);
  },
);

export { httpClient };
